import React from "react";
import {
  View,
  StyleSheet,
  Modal,
  TouchableWithoutFeedback,
} from "react-native";
import OrderDetails from "./OrderDetails";
import { Order } from "@/app/types/order";

type OrderDetailsModalProps = {
  visible: boolean;
  order: Order;
  onClose: () => void;
};

const OrderDetailsModal = ({ visible, onClose }: OrderDetailsModalProps) => {
  return (
    <Modal
      transparent={true}
      animationType="fade"
      visible={visible}
      onRequestClose={onClose}
      accessibilityViewIsModal={true}
    >
      <TouchableWithoutFeedback onPress={onClose}>
        <View
          style={styles.backdrop}
          accessible={true}
          accessibilityRole="alert"
          accessibilityLabel="Order details modal"
        >
          <TouchableWithoutFeedback>
            <OrderDetails />
          </TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    backgroundColor: "white",
    padding: 20,
    borderRadius: 10,
    alignItems: "center",
  },
  modalText: {
    fontSize: 18,
    fontWeight: "bold",
  },
});

export default OrderDetailsModal;
